import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          {isHome ? (
            <h1>
              <Link to="/" className="flex items-center gap-2 cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className={`font-heading font-bold text-xl whitespace-nowrap ${isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'}`}>
                  糖心视频
                </span>
              </Link>
            </h1>
          ) : (
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading font-bold text-xl text-foreground-900 whitespace-nowrap">
                糖心视频
              </span>
            </Link>
          )}

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                      : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer whitespace-nowrap ${
              isScrolled || !isHome ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
              下载APP
            </button>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${
              isScrolled || !isHome ? 'text-foreground-700' : 'text-background-50'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/60 py-3 px-4">
            <div className="flex flex-col gap-1">
              <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 cursor-pointer">首页</Link>
              {categories.slice(0, 4).map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 cursor-pointer">{cat.name}</Link>
              ))}
              <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 cursor-pointer">关于我们</Link>
              <button className="mt-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
                下载APP
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}